import exitIfCLIOutOfDate from './exitIfCLIOutOfDate';
import initSentry from './initSentry';

export default ({ sentry = true, exitIfOutOfDate = true } = {}) => {
  if (sentry) {
    initSentry();
  }

  if (exitIfOutOfDate) {
    exitIfCLIOutOfDate();
  }
};
